<template>
  <article>
    <section class="xbed-sub-title">
      <span>店长值班状态</span>
    </section>

    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>店长值班管理</BreadcrumbItem>
        <BreadcrumbItem>店长值班状态</BreadcrumbItem>
      </Breadcrumb>
    </section>

    <section style="margin-top:20px">
      <Form inline>
        <FormItem label="城市" prop="city" :label-width="60">
          <Select style="width:180px" ref="resetSelect" v-model="search.cityId" clearable filterable>
            <Option v-for="(city, index) in allCities" :key="index" :value="city.id">{{city.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="门店" prop="chainName" :label-width="60">
          <Select style="width:180px" v-model="search.chainId" ref="chainName" clearable filterable>
            <Option v-for="hotel in allHotels" :key="hotel.sourceId" :value="hotel.sourceId">{{hotel.sourceId + '_' + hotel.sourceName}}</Option>
          </Select>
        </FormItem>
        <FormItem label="店长" :label-width="60">
          <Input v-model="search.manager"></Input>
        </FormItem>
        <FormItem :label-width="50" label="">
          <Button type="primary" @click="searchByPrama">查询</Button>
        </FormItem>
      </Form>
      
      <div style="margin: 10px;overflow: hidden">
        <Page :page-size="search.size" show-total show-sizer :current="search.page" :total="total" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
      </div>
      <Table :columns="columns" :data="list"></Table>
    </section>
    <!-- 值班店长-->
    <div v-if="modal.display">
      <Modal v-model="modal.display" ref="modalDisplay" :title="modal.step == 3 ? '确认结束值班？' : '值班店长'" :loading="true" :width="500" @on-cancel="cancelEditDelegateState">
        <div v-if="modal.step == 1"  style="font-size: 14px">
          <span>当前值班店长：{{ delegate.currentManager ? `${delegate.currentManager.userName + '_' + delegate.currentManager.phone}` : '无'}}</span>
        </div>  
        <div v-if="modal.step == 2"  style="font-size: 14px">
          <Form>
            <FormItem label="当前值班店长：">
              <Select v-model="modal.userId" style="width:300px">
                <Option v-for="item in delegate.managerList" :key="item.userId" :value="item.userId">{{item.userName + '_' + item.phone}}</Option>
              </Select>
            </FormItem>
          </Form>
        </div>
        <span v-if="modal.step == 3"  style="font-size: 14px">门店将变为无人值班状态</span>
        <div slot="footer">
          <Button type="primary" v-if="modal.step == 1" @click="modal.step = 2">切换店长</Button>
          <Button type="primary" v-if="modal.step == 1 && delegate.currentManager" @click="modal.step = 3">结束值班</Button>
          <Button type="primary" :loading="modalLoading" v-if="modal.step == 2" :disabled="modal.userId == ''" @click="handleBegin">开始值班</Button>
          <Button v-if="modal.step == 3" @click="cancelEditDelegateState">取消</Button>
          <Button type="primary" :loading="modalLoading" v-if="modal.step == 3" @click="handleFinish">结束值班</Button>
        </div>
      </Modal>
    </div>
  </article>
</template>
  
<script>
import API from "../../api";
import Utils from "../../utils";
export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.headerENV = Utils.aliHeaderEnv(this.env);

    this.apiHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), //走阿里云需要
      'Authorization': Utils.findFromLocalStorage("Author-token"),//走阿里云需要
      // 'group': 'dev',
      // 'secret': 'c98606c16859082e3c80a2ae2493207b' // 开发环境直接走ip请求才需要加该参数
    }
  },
  mounted() {
    this.$Notice.config({
      top: 100
    });
    this.getQueryDatas()
    this.getDelegateStats()
  },
  data() {
    return {
      stop: false,
      validStatus: true,
      list: [],
      searchCitise: [],
      total: 0,
      search: {
        manager: '',
        cityId: '',
        chainId: '',
        page: 1,
        size: 20
      },
      columns: [
        {
          title: "城市",
          align: 'center',
          render: (h, param) => {
            return h('span', param.row.provinceName + param.row.cityName)
          }
        },
        {
          title: "门店",
          align: 'center',
          render: (h, param) => {
            return h('span', param.row.chainId + '_' + param.row.chainName)
          }
        },
        {
          title: "派遣店长",
          align: 'center',
          render: (h, param) => {
            return h('div', param.row.managerList.map(item => {
              return h('div',{
                style: {
                  textAlign: 'left'
                }
              }, `${item.isMainManager ? '主' : '副'}：${item.userName}_${item.phone}`)
            }))
          }
        },
        {
          title: "当前值班店长",
          align: 'center',
          key: 'delegate',
          render: (h, param) => {
            let manager = param.row.currentManager;
            return h('span', manager ? `${manager.userName}_${manager.phone}` : '无');
          }
        },
        {
          title: "操作",
          width: 200,
          align: 'center',
          render: (h, param) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.editDelegateState(param.row)
                  }
                }
              }, '管理值班状态'),
            ])
          }
        }
      ],
      delegate: {},
      allCities: [],
      allHotels: [],
      modal: {
        display: false, 
        step: 1, // 1：展示 2:切换店长 3:结束值班
        userId: ''
      },
      modalLoading: false
    };
  },
  methods: {
    searchByPrama() {
      this.search.page = 1
      this.search.size = 20
      this.getDelegateStats()
    },
    changePage(page) {
      this.search.page = page
      this.getDelegateStats()
    },
    changePageSize(size) {
      this.search.page = 1
      this.search.size = size
      this.getDelegateStats()
    },

    async getQueryDatas() {
      let selectListResp = ( await API.omsAPI[this.env].php.querySelectList() ).data;
      let citys = ( await API.omsAPI[this.env].clientServer.getAllCities(this.apiHeaders) ).data;
      this.allCities = citys;
      this.allHotels = selectListResp.data.chain;
    },

    async getDelegateStats() {

      try {
        let params = {
          ...this.search
        }
        let res = (await API.omsAPI[this.env].clientServer.getChainManagerList(params, this.apiHeaders)).data
        if (res) {
          this.list = res.list;
          this.total = res.total;
        }
      } catch (error) {
        console.info(error);
      }
    },

    getNameById(id, list){
      return list.filter(item => {
        return item.id === id
      })
    },
    getIdByName(name, list) {
      return list.filter(item => {
        return item.name == name
      })
    },

    //编辑值班状态
    editDelegateState(item) {
      if ( !Utils.hasPermission( 'aseInfo_manageDelegateState' ) ) {
        this.$Notice.error({
            title: "提示",
            desc: '没有管理值班状态权限'
          });
        return
      }

      this.modalLoading = false;
      this.modal.display = true;
      this.modal.step = 1;
      this.modal.userId = item.currentManager ? item.currentManager.userId : '';
      this.delegate = {...item};
    },

    cancelEditDelegateState() {
      this.modal = {
        display: false,
        step: 1,
        userId: ''
      }
    },

    /**
     * 结束值班
     */
    async handleFinish() {
      this.modalLoading = true
      
      let params = {
        chainId: this.delegate.chainId,
        operator: this.username,
        clientId: 5
      }

      let res = (await API.omsAPI[this.env].clientServer.overDuty(params, this.apiHeaders)).data;
      
      this.modalLoading = false;
      if (res) {
        this.$Notice.success({
          title: '操作成功'
        })
        this.getDelegateStats()
        this.cancelEditDelegateState()

      } else {
        this.$Notice.error({
          title: '操作失败',
          desc: res.msg
        })
      }
    },
    
    /**
     * 开始值班
     */
    async handleBegin() {
      this.modalLoading = true
      
      let params = {
        chainId: this.delegate.chainId,
        userId: this.modal.userId,
        operator: this.username,
        clientId: 5
      }

      let res = (await API.omsAPI[this.env].clientServer.changeDutyManager(params, this.apiHeaders)).data;

      this.modalLoading = false;
      if (res) {
        this.$Notice.success({
          title: '操作成功'
        })
        this.getDelegateStats()
        this.cancelEditDelegateState()
      } else {
        this.$Notice.error({
          title: '操作失败',
          desc: res.msg
        })
      }
    },

    // 当关闭选择城市选择框没有选择城市时，清空搜索框内容
		cityOpenChange(res) {
			if (!res && !this.search.cityId) {
				this.$refs.resetSelect.clearSingleSelect()
			}
    },

  },
};
</script>



// WEBPACK FOOTER //
// src/pages/delegate-management/delegate-state.vue